module.exports = __webpack_public_path__ + "img/wx.88dbadb8.png";